import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/*
 * tailwind-merge only knows Tailwind's own scales, and the brand replaces
 * two of them outright (`packages/brand/src/theme.css`). Left untold, it
 * reads `rounded-panel` and `shadow-pop` as classes from some other group
 * and keeps them alongside the `rounded-none` meant to override them —
 * both land in the class list and stylesheet order picks the winner, so a
 * dialog asked to square its corners stays round. Naming the scales here
 * puts them back in the group they belong to, where later wins.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: { borderRadius: ['field', 'card', 'panel', 'pill'] },
    classGroups: { shadow: [{ shadow: ['soft', 'lift', 'pop', 'glow'] }] },
  },
});

/**
 * Merge class names so later Tailwind utilities win over earlier ones.
 * Every component takes a `className` and funnels it through this, which is
 * what makes them overridable at the call site.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
